export default __webpack_public_path__ + "static/media/BusinessInTheTimeOfContagion.d732d2c1.png";